import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bad1842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "toolbar-container" }
const _hoisted_2 = { id: "scrolling-tools" }
const _hoisted_3 = { id: "inner-container" }
const _hoisted_4 = { id: "fixed-tools" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegularToolbarItem = _resolveComponent("RegularToolbarItem")!
  const _component_TextToSpeechItem = _resolveComponent("TextToSpeechItem")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.basicEnabled)
            ? (_openBlock(), _createBlock(_component_RegularToolbarItem, {
                key: 0,
                icon: "fa-calculator",
                title: _ctx.$t('toolbar.calc_basic'),
                identifier: "basic-calculator"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.scientificEnabled)
            ? (_openBlock(), _createBlock(_component_RegularToolbarItem, {
                key: 1,
                icon: "fa-calculator",
                title: _ctx.$t('toolbar.calc_sci'),
                identifier: "scientific-calculator"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.graphingEnabled)
            ? (_openBlock(), _createBlock(_component_RegularToolbarItem, {
                key: 2,
                icon: "fa-calculator",
                title: _ctx.$t('toolbar.calc_graph'),
                identifier: "graphing-calculator"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_TextToSpeechItem, {
          "adjust-for-focus-mode": _ctx.adjustForFocusMode()
        }, null, 8, ["adjust-for-focus-mode"]), [
          [_vShow, _ctx.textToSpeechEnabled()]
        ])
      ])
    ])
  ]))
}